import { render, staticRenderFns } from "./advertising-position.vue?vue&type=template&id=8dd99f1e&scoped=true"
import script from "./advertising-position.vue?vue&type=script&lang=ts"
export * from "./advertising-position.vue?vue&type=script&lang=ts"
import style0 from "./advertising-position.vue?vue&type=style&index=0&id=8dd99f1e&prod&lang=stylus&module=true"
import style1 from "./advertising-position.vue?vue&type=style&index=1&id=8dd99f1e&prod&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8dd99f1e",
  null
  
)

export default component.exports